import { Component, OnInit } from '@angular/core';
import { SchedulerService } from 'src/app/service/scheduler/service/scheduler.service';
import { Router } from '@angular/router';
import { getDashboardActiveState } from 'src/app/app.module';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  schedules: any[];
  apiDashboardState: boolean;

  constructor(private router: Router, private schedulerService: SchedulerService) { }

  ngOnInit() {
		this.schedulerService.search('', 'createdDate', 'desc', 0, 100)
			.subscribe(resultPage => {
			this.schedules = resultPage.content;
		});
		this.apiDashboardState = getDashboardActiveState();
  }

	onScheduler(scheduler: any) {
		if (scheduler.taskHistoryId) {
			this.router.navigate(['/main', { outlets: { content: 'service/scheduler/detail/' + scheduler.id + '/' }}], { queryParams: { taskHistoryId: scheduler.taskHistoryId }});
		} else {
			this.router.navigate(['/main', { outlets: { content: 'service/scheduler/detail/' + scheduler.id + '/' }}]);
		}
	}
}
